module.exports = __webpack_public_path__ + "img/detBannerRed.09a6889a.jpg";